import type { ExtractPropTypes } from 'vue'
import { PropType } from 'vue'
export const cosFooterButtonProps = () => ({
  disabled: {
    type: Boolean,
    default: true // edit detail
  },
  loading: {
    type: Boolean
  },
  value: {
    type: [Object, Array]
  },
  resetValue: {
    type: [Object, Array]
  },
  formRef: {
    type: Object
  },
  hideOk: {
    type: Boolean,
    default: false
  },
  editUrl: {
    type: String
  },
  workCode: {
    type: String
  },
  okText: {
    type: String
  },
  permissionPage: {
    type: Object as PropType<{
      save: string // 新增、编辑保存按钮-权限控制
      edit: string // 跳转编辑界面-权限控制
    }>,
    default: () => {
      return {}
    }
  }
})
export type CosFooterButtonProps = Partial<ExtractPropTypes<ReturnType<typeof cosFooterButtonProps>>>
export default cosFooterButtonProps
